export const getMenderConnectionStatus = async (unitId, serial) => {
  const response = await fetch(`/api/mender-status?unitId=${encodeURIComponent(unitId)}&serial=${encodeURIComponent(serial)}`);

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${response.status})`);
  }

  return response.json();
};

// Triggers a native browser download instead of fetching the file into memory first.
// The server sets Content-Disposition: attachment, so the browser streams it straight
// to disk, shows it in the OS/browser download manager immediately, and it keeps going
// even if the user navigates elsewhere in the app.
export const downloadUnitLog = (unitId, serial, logFile = 'log.log') => {
  const url = `/api/mender-log?unitId=${encodeURIComponent(unitId)}&serial=${encodeURIComponent(serial)}&file=${encodeURIComponent(logFile)}`;
  const anchor = document.createElement('a');
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
